import React from 'react'
import { Button as MuiButton, ButtonProps } from '@material-ui/core'

type ButtonBaseProps = Omit<
  ButtonProps,
  | 'centerRipple'
  | 'disableElevation'
  | 'disableFocusRipple'
  | 'disableRipple'
  | 'disableTouchRipple'
  | 'focusRipple'
  | 'onFocusVisible'
  | 'TouchRippleProps'
>

interface ExtendedButtonProps extends ButtonBaseProps {
  'data-testid'?: string // Define the data attribute type
}

/** Primary UI component for user interaction */
export const Button = ({ ...rest }: ExtendedButtonProps): JSX.Element => (
  <MuiButton {...rest}></MuiButton>
)
